/* unplugin-vue-components disabled */import { render } from "./Stake.vue?vue&type=template&id=293d30b2&scoped=true"
import script from "./Stake.vue?vue&type=script&lang=js"
export * from "./Stake.vue?vue&type=script&lang=js"

import "./Stake.vue?vue&type=style&index=0&id=293d30b2&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-293d30b2"]])

export default __exports__